import * as Constants from '../Constants';
import SwiperJS from '../../../js/vendor/swiper.min.js';
import Swiper, { SelectableElement, SwiperOptions } from 'swiper';
import {ISwiperSettings} from "../../interfaces/ISwiperSettings";

export function AcrMultiColumn( ) {

  let multiColumn: HTMLElement;
  let mediaMatchSwiper: MediaQueryList;
  let hoverVideo: HTMLVideoElement;
  let acrMultiColumnContainer: HTMLElement;
  let acrMultiColumnList: HTMLElement;
  let multiColumnSwiperContainer: HTMLElement;
  let swiperPagination: SelectableElement;
  let arrowLeft: SelectableElement;
  let arrowRight: SelectableElement;
  let multiColumnSwiper: Swiper;
  let currentSlide: HTMLElement;
  let tabSettings: ISwiperSettings;
  const acrMultiColumnListSelector = '.js-multi-column-list';
  const acrMultiColumnContainerSelector = '.js-multi-column-container';
  const swiperSlideActiveSelector = '.swiper-slide-active';
  const swiperContainerSelector = '.js-swiper-container';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  const mobileSwiper = 'mobile-swiper';
  const tabletSwiper = 'tablet-swiper';

  const initSwiper = (mediaMatch: MediaQueryList, event?: MediaQueryListEvent): any => {
    const deleteInstance = false;
    const cleanStyles = true;

    if (mediaMatch && mediaMatch.matches) {
      const multiColumnSwiperOptions: SwiperOptions = {
        slidesPerView: 1,
        loop: false,
        effect: 'fade',
        allowTouchMove: tabSettings.SettingSwiperDraggable == '1',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: arrowRight,
          prevEl: arrowLeft,
        }
      };

      if (tabSettings.SettingSwiperDots == '1') {
        multiColumnSwiperOptions.pagination = {
          el: swiperPagination,
          clickable: true
        };
      }
      multiColumnSwiper = new SwiperJS(multiColumnSwiperContainer, multiColumnSwiperOptions);

    } else {
      currentSlide = multiColumn.querySelector(swiperSlideActiveSelector);
      if (currentSlide) {
        multiColumnSwiper.destroy(deleteInstance, cleanStyles);
      }
    }
  }

  const startVideo = (event: Event) => {
    hoverVideo = ((event.target) as Element).querySelector('video');
    if (hoverVideo.offsetWidth > 0 && hoverVideo.offsetHeight > 0) {
      (event.target as Element).querySelector('picture').style.opacity = '0';
      hoverVideo.style.opacity = '1';
      hoverVideo.play();
    }
  }

  const stopVideo = (event: Event) => {
    hoverVideo = (event.target as Element).querySelector('video');
    if (hoverVideo.offsetWidth > 0 && hoverVideo.offsetHeight > 0) {
      hoverVideo.pause();
      hoverVideo.currentTime = 0;
      hoverVideo.style.opacity = '0';
      (event.target as Element).querySelector('picture').style.opacity = '1';
    }
  }

  const initVideoHover = () => {
    multiColumn.querySelectorAll('.tile').forEach((el) => {
      hoverVideo = el.querySelector('video');
      if (hoverVideo) {
        el.addEventListener('mouseenter', startVideo);
        el.addEventListener('mouseleave', stopVideo);
      }
    });
  }

  const initSelectors = (element: HTMLElement) => {
    multiColumn = element;
    acrMultiColumnContainer = multiColumn.querySelector(acrMultiColumnContainerSelector);
    acrMultiColumnList = multiColumn.querySelector(acrMultiColumnListSelector);
    arrowLeft = multiColumn.querySelector(arrowLeftSelector) as HTMLElement;
    arrowRight = multiColumn.querySelector(arrowRightSelector) as HTMLElement;
    multiColumnSwiperContainer = element.querySelector(swiperContainerSelector);
    swiperPagination = element.querySelector(swiperPaginationSelector) as HTMLElement;
  }

  const bindEvents = () => {
    if (tabSettings.SettingMobileSwiper || tabSettings.SettingTabletSwiper) {
      // @ts-ignore
      mediaMatchSwiper.addListener(initSwiper);
    }
  }

  const getTabSettings = () => {
    try {
      tabSettings = JSON.parse(multiColumn.getAttribute('data-module-settings'));
    } catch (err) {
      tabSettings = {};
    }
  }

  const defineMatchMedia = () => {
    if (tabSettings.SettingMobileSwiper && tabSettings.SettingTabletSwiper) {
      mediaMatchSwiper = window.matchMedia(`(max-width:${Constants.breakpoints.lg - 1}px)`);
    } else if (tabSettings.SettingMobileSwiper) {
      mediaMatchSwiper = window.matchMedia(`(max-width:${Constants.breakpoints.md - 1}px)`);
    } else if (tabSettings.SettingTabletSwiper) {
      mediaMatchSwiper = window.matchMedia(`(min-width:${Constants.breakpoints.md}px) and (max-width:${Constants.breakpoints.lg - 1}px)`);
    } else {
      mediaMatchSwiper = undefined;
    }
  }

  // Function that adds classes required for any setting enable
  const verifySwiperDevice = (element: HTMLElement) => {
    if (tabSettings.SettingMobileSwiper) {
      element.querySelector(acrMultiColumnContainerSelector).classList.add(mobileSwiper);
    }
    if (tabSettings.SettingTabletSwiper) {
      element.querySelector(acrMultiColumnContainerSelector).classList.add(tabletSwiper);
    }
  }

  const init = (element: HTMLElement) => {
    initSelectors(element);
    getTabSettings();
    defineMatchMedia();
    initSwiper(mediaMatchSwiper);
    verifySwiperDevice(element);
    initVideoHover();
    bindEvents();
  }

  return {init};

}
